import api from './api';

const BASE_URL = '/admin/forms';

export const FormsService = {
  // Get all forms
  async getForms() {
    const response = await api.get(BASE_URL);
    return response.data;
  },

  // Get form by ID
  async getFormById(id) {
    const response = await api.get(`${BASE_URL}/${id}`);
    return response.data;
  },

  // Create new form
  async createForm(formData) {
    const response = await api.post(BASE_URL, formData);
    return response.data;
  },

  // Update form
  async updateForm(id, formData) {
    const response = await api.put(`${BASE_URL}/${id}`, formData);
    return response.data;
  },

  // Delete form
  async deleteForm(id) {
    const response = await api.delete(`${BASE_URL}/${id}`);
    return response.data;
  },

  // Duplicate form
  async duplicateForm(id, name = null) {
    const response = await api.post(`${BASE_URL}/${id}/duplicate`, { name });
    return response.data;
  },

  // Public forms (for booking page)
  async getPublicForms() {
    const response = await api.get('/api/forms/public');
    return response.data;
  },

  // Get public form by ID
  async getPublicFormById(id) {
    const response = await api.get(`/api/forms/public/${id}`);
    return response.data;
  }
};

export default FormsService;
